import Client from './helpers/client'
require('dotenv').config()

const url = process.env.REACT_APP_AMS_API || 'http://localhost:3001';
const api = new Client(url);

export default api;